<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :maskClosable="false"
    :visible="open"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="行业名称" prop="industryCategoryName">
        <a-input v-model="form.industryCategoryName" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
// import { getData, addData, updateData } from '@/api/system/dict/data'
import { addIndustryCategory, industryCategoryDetail, editIndustryCategory } from '@/api/system/industry'
export default {
  name: 'CreateDataForm',
  props: {
    industryCategoryType: {
      type: Number,
      required: true
    }
    // statusOptions: {
    //   type: Array,
    //   required: true
    // },
    //  open: {
    //   type: Boolean,
    //   required: true
    // }
  },
  components: {},
  data () {
    return {
      open: false,
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        industryCategoryName: undefined,
        industryCategoryType: undefined,
        id: undefined,
        parentId: undefined
      },
      rules: {
        industryCategoryName: [{ required: true, message: '请输入行业名称', trigger: 'blur' }]
      }
    }
  },
  filters: {},
  created () {},
  computed: {},
  watch: {},
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        industryCategoryName: undefined,
        industryCategoryType: undefined,
        id: undefined
      }
    },
    /** 新增按钮操作 */
    handleAdd (parentId) {
      this.reset()
      this.open = true
      this.formTitle = '添加行业分类'
      this.form.industryCategoryType = this.industryCategoryType
      if (parentId) {
        this.form.parentId = parentId
      }
    },
    /** 修改按钮操作 */
    handleUpdate (row, type) {
      this.reset()
      this.open = true
      this.formTitle = '修改行业分类'
       industryCategoryDetail(row.id).then((res) => {
          const { code, data } = res
          if (code === 200) {
            delete data.industryCategoryType
            this.form = data
          }
        })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            this.submitLoading = true
            const parmars = this.form
            editIndustryCategory(parmars)
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success('修改成功')
                  this.open = false
                  this.$emit('ok')
                }
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            this.submitLoading = true
            const parmars = this.form
            addIndustryCategory(parmars)
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success('新增成功')
                  this.open = false
                  this.$emit('ok')
                }
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
